
import { ManagerIcon } from '../../../assets/icons/icons';
import Popup from '../../Popup/Popup';
import './OrderErrorPopup.css';

function OrderErrorPopup({ isOpen, popupName, setOpen }) {
    return (
        <Popup
            isOpen={isOpen}
            popupName={popupName}
            setOpen={setOpen}
        >
            <div className='oreder-error-popup'>
                <ManagerIcon mainClassName={'oreder-error-popup__icon'} fillClassName={'oreder-error-popup__icon_fill'} />
                <p className="oreder-error-popup__text">An error occurred when creating an order</p>
                <p className="oreder-error-popup__subtext">Try again later, or contact technical support.</p>
            </div>
        </Popup>

    );
}

export default OrderErrorPopup